import "./WhatIfUniverse.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import { CosmicBackground } from "@/components/cosmic/CosmicBackground";
import UniverseIntro from "./sections/UniverseIntro";
import LawRewriter from "./sections/LawRewriter";
import UniverseQuiz from "./sections/UniverseQuiz";
import WhatIfFaq from "./sections/WhatIfFaq";
export default function WhatIfUniversePage() {
  return <div className="relative min-h-[100svh] w-full max-w-full bg-background text-foreground overflow-x-clip selection:bg-primary/30 selection:text-primary">
      {/* Root CosmicBackground fixed behind whole page with violet accent */}
      <CosmicBackground fixed accent="violet" density={1} />

      {/* Main page content layer with relative z-10 */}
      <div className="relative z-10 flex flex-col min-h-[100svh] w-full max-w-full">
        <Header />
        <main className="flex-1 w-full max-w-full">
          <UniverseIntro />
          <LawRewriter />
          <UniverseQuiz />
          <WhatIfFaq />
        </main>
        <Footer />
      </div>
    </div>;
}